// extracted by mini-css-extract-plugin
export default {"readOnlyValue":"PsUt__u__USO7WmLFwHA"};